// extracted by mini-css-extract-plugin
export default {"externalTopbar":"ExternalTopbar-module__externalTopbar--YrW97","left":"ExternalTopbar-module__left--aF5WK","animatedBackground":"ExternalTopbar-module__animatedBackground--BxXEA"};